import React from "react";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DoNotDisturbOnOutlinedIcon from "@mui/icons-material/DoNotDisturbOnOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import { SvgIconProps } from "@mui/material";
import { FileRepoStatus } from "store/types";

/** Shared UI config (label / colors / icon) for a file business status (`file_status`). */
export interface FileStatusOption {
  value: FileRepoStatus;
  label: string;
  bgcolor: string;
  iconColor: string;
  Icon: React.ComponentType<SvgIconProps>;
}

export const FILE_STATUS_OPTIONS: FileStatusOption[] = [
  { value: "new", label: "New", bgcolor: "#f6f8fc", iconColor: "#496682", Icon: ErrorOutlineIcon },
  { value: "in_process", label: "In Process", bgcolor: "#e2e8fa", iconColor: "#3b5998", Icon: SyncOutlinedIcon },
  {
    value: "waiting_for_information",
    label: "Waiting for Information",
    bgcolor: "#fde4bd",
    iconColor: "#c77700",
    Icon: ScheduleOutlinedIcon
  },
  { value: "done", label: "Done", bgcolor: "#98fcd9", iconColor: "#1b7a4a", Icon: CheckCircleOutlineIcon },
  {
    value: "not_relevant",
    label: "Not Relevant",
    bgcolor: "#dbe8f5",
    iconColor: "#496682",
    Icon: DoNotDisturbOnOutlinedIcon
  }
];

/** Resolve a status to its config; falls back to the first option for unknown/null values. */
export const getFileStatusConfig = (status: FileRepoStatus | string | null): FileStatusOption =>
  FILE_STATUS_OPTIONS.find((option) => option.value === status) ?? FILE_STATUS_OPTIONS[0];
